{
	"en-US": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"en-CA": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"en-IN": {
		"home": "/petition-guides",
		"createPetition": "/petition-guides/create-a-petition",
		"sharePetition": "/petition-guides/share-your-petition",
		"buildMomentum": "/petition-guides/build-momentum",
		"reachMedia": "/petition-guides/media",
		"engageDecisionMaker": "/petition-guides/engage-decision-makers",
		"declareVictory": "/petition-guides/declare-petition-victory"
	},
	"en-AU": {
		"home": "https://guide.change.org/home_aus",
		"createPetition": "https://guide.change.org/create_aus",
		"sharePetition": "https://guide.change.org/share_aus",
		"buildMomentum": "https://guide.change.org/build-momentum_aus",
		"reachMedia": "https://guide.change.org/media-outreach_aus",
		"engageDecisionMaker": "https://guide.change.org/engage_aus",
		"declareVictory": "https://guide.change.org/declare-victory_aus"
	},
	"en-GB": {
		"home": "https://guide.change.org/home-uk",
		"createPetition": "https://guide.change.org/create-uk",
		"sharePetition": "https://guide.change.org/share-uk",
		"buildMomentum": "https://guide.change.org/buildmomentum-uk",
		"reachMedia": "https://guide.change.org/media-uk",
		"engageDecisionMaker": "https://guide.change.org/decision-makers-uk",
		"declareVictory": "https://guide.change.org/declare-victory-uk"
	},
	"de-DE": {
		"home": "/l/de/p/kampagnentraining",
		"createPetition": "/l/de/p/petition-starten",
		"sharePetition": "/l/de/p/kampagne-verbreiten",
		"buildMomentum": "/l/de/p/erfolg-ausbauen",
		"reachMedia": "/l/de/p/massenmedien-nutzen",
		"engageDecisionMaker": "/l/de/p/entscheidungstraegerinnen-kontaktieren",
		"declareVictory": "/l/de/p/erfolg-erklaeren"
	},
	"es-ES": {
		"home": "https://guide.change.org/comousarchange",
		"createPetition": "https://guide.change.org/iniciatupeticion",
		"sharePetition": "https://guide.change.org/difundetupeticion",
		"buildMomentum": "https://guide.change.org/hazruidocontucampana",
		"reachMedia": "https://guide.change.org/llegaalosmediosdecomunicacion",
		"engageDecisionMaker": "https://guide.change.org/entregalasfirmas",
	 	"declareVictory": "https://guide.change.org/declaraelvictoria"
	},
	"es-419": {
		"home": "http://www.comousarchange.org",
		"createPetition": "http://www.comousarchange.org/primerospasos",
		"sharePetition": "http://www.comousarchange.org/compartir",
		"buildMomentum": "http://www.comousarchange.org/ruido",
		"reachMedia": "http://www.comousarchange.org/medios",
		"engageDecisionMaker": "http://www.comousarchange.org/destinatario",
		"declareVictory": "http://www.comousarchange.org/victoria/"
	},
	"es-AR": {
		"home": "/l/ar",
		"createPetition": "http://www.comousarchange.org/primerospasos",
		"sharePetition": "http://www.comousarchange.org/compartir",
		"buildMomentum": "http://www.comousarchange.org/ruido",
		"reachMedia": "http://www.comousarchange.org/medios",
		"engageDecisionMaker": "http://www.comousarchange.org/destinatario",
		"declareVictory": "http://www.comousarchange.org/victoria"
	},
	"fr-FR": {
		"home": "https://guide.change.org/accueil",
		"createPetition": "https://guide.change.org/lancez",
		"sharePetition": "https://guide.change.org/partagez",
		"buildMomentum": "https://guide.change.org/mobilisez",
		"reachMedia": "https://guide.change.org/mediatisez",
		"engageDecisionMaker": "https://guide.change.org/dialoguez",
		"declareVictory": "https://guide.change.org/celebrez"
	},
	"hi-IN": {
	},
	"id-ID": {
	},
	"it-IT": {
		"home": "https://guide.change.org/home-italia",
		"createPetition": "https://guide.change.org/crea",
		"sharePetition": "https://guide.change.org/condividi",
		"buildMomentum": "https://guide.change.org/construisci",
		"reachMedia": "https://guide.change.org/media-italia",
		"engageDecisionMaker": "https://guide.change.org/decisore",
		"declareVictory": "https://guide.change.org/vittoria"
	},
	"ja-JP": {
		"home": "/l/jp/guide00-home",
		"createPetition": "/l/jp/guide01",
		"sharePetition": "/l/jp/guide02",
		"buildMomentum": "/l/jp/guide03",
		"reachMedia": "/l/jp/guide04",
		"engageDecisionMaker": "/l/jp/guide05",
		"declareVictory": "/l/jp/guide07"
	},
	"ko-KR": {
	},
	"pt-BR": {
		"home": "http://www.comousarachange.org/",
		"createPetition": "http://www.comousarachange.org/como-fazer-abaixo-assinado",
		"sharePetition": "http://www.comousarachange.org/como-espalhar",
		"buildMomentum": "http://www.comousarachange.org/como-fazer-barulho",
		"reachMedia": "http://www.comousarachange.org/como-sair-na-midia",
		"engageDecisionMaker": "http://www.comousarachange.org/como-falar-com-quem-decide",
		"declareVictory": "http://www.comousarachange.org/como-declarar-vitoria"
	},
	"ru-RU": {
		"home": "https://russianguidechange.org/516212259308",
		"createPetition": "https://russianguidechange.org/startapetition",
		"sharePetition": "https://russianguidechange.org/422150326827",
		"buildMomentum": "https://russianguidechange.org/532354153253",
		"reachMedia": "https://russianguidechange.org/516212259308",
		"engageDecisionMaker": "https://russianguidechange.org/733073910238",
		"declareVictory": "https://russianguidechange.org/202304372910"
	},
	"th-TH": {
	},
	"tr-TR": {
	}
}
